import { render, staticRenderFns } from "./SelectedItemHeader.vue?vue&type=template&id=153eb4a4&scoped=true&"
import script from "./SelectedItemHeader.vue?vue&type=script&lang=js&"
export * from "./SelectedItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./SelectedItemHeader.vue?vue&type=style&index=0&id=153eb4a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153eb4a4",
  null
  
)

export default component.exports